import React, { PureComponent } from 'react';
import Button from '~/UI/Button';
import LayoutConstraint from '~/UI/LayoutConstraint/LayoutConstraint';
import Popover from '~/UI/Popover';
import darkPopoverStyles from '~/UI/Popover/dark.less';

import styles from './styles.less';

interface Props {
	missingPricesPercentage: number;
	reference: React.ReactNode;
	onClose(): void;
}

interface State {
	temporarilyHidden: boolean;
}

export default class MissingPricesTooltip extends PureComponent<Props, State> {
	state = {
		temporarilyHidden: false,
	};

	hideTimeoutId: NodeJS.Timeout | null = null;

	componentDidMount() {
		this.scheduleHideTimeout();
	}

	componentWillUnmount() {
		this.clearHideTimeout();
	}

	render() {
		const {
			props: { missingPricesPercentage, reference },
			state: { temporarilyHidden },
		} = this;

		return missingPricesPercentage > 70 && !temporarilyHidden ? (
			<LayoutConstraint reference={<span>{reference}</span>}>
				{({ referenceRect }) => (
					<Popover
						position='top'
						referenceRect={referenceRect}
						styles={darkPopoverStyles}
						width={290}
						onClose={this.close}
						onMouseEnter={this.clearHideTimeout}
						onMouseLeave={this.scheduleHideTimeout}
					>
						{this.renderContent()}
					</Popover>
				)}
			</LayoutConstraint>
		) : (
			<>{reference}</>
		);
	}

	renderContent() {
		const { missingPricesPercentage, onClose } = this.props;

		if (missingPricesPercentage > 90) {
			return (
				<div className={styles.content} onClick={onClose}>
					<h2 className={styles.heading}>TIP: price level changed</h2>
					<p className={styles.paragraph}>
						We changed the viewed price level to <strong>First available price</strong> in the dataset because there was
						low number of prices available at previously selected level. You can switch between various price levels by{' '}
						<strong>clicking on the $ icon</strong>.
					</p>

					<Button styles={styles} onClick={onClose}>
						Ok, don{"'"}t show again
					</Button>
				</div>
			);
		}

		return (
			<div className={styles.content} onClick={onClose}>
				<h2 className={styles.heading}>TIP: select price level</h2>
				<p className={styles.paragraph}>
					You can <strong>set various price</strong> levels when you click on the $ icon. If you want to see as many{' '}
					<strong>price points</strong> as possible, <strong>select First available price</strong> in the dataset
				</p>

				<Button styles={styles} onClick={onClose}>
					Ok, don{"'"}t show again
				</Button>
			</div>
		);
	}

	scheduleHideTimeout = () => {
		this.hideTimeoutId = setTimeout(() => this.setState({ temporarilyHidden: true }), 30 * 1000);
	};

	clearHideTimeout = () => {
		if (this.hideTimeoutId !== null) {
			clearTimeout(this.hideTimeoutId);
		}
	};

	close = () => {
		this.clearHideTimeout();
		this.setState({ temporarilyHidden: true });
	};
}
